<template>
  <j-modal
    title="新增"
    centered
    :width="630"
    :ok="false"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <DepartInfo ref="DepartInfo" :isModal="true" :changePlanId="changePlanId" @emit="emitFromDepartInfo"></DepartInfo>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import DepartInfo from './DepartInfo'

export default {
  name: 'DepartModal',
  components: { DepartInfo },
  props: {
    // 组织变更计划ID
    changePlanId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: '',
      visible: false,
      url: {
        add: '/blaze-sys/k00/k0002/DepartManage/add',
      },
    }
  },
  created() {},
  methods: {
    add(departId, currCategory) {
      this.visible = true

      this.$nextTick(() => {
        this.$refs.DepartInfo.add(departId, currCategory)
      })
    },
    handleOk() {
      this.$refs.DepartInfo.handleSubmit()
    },
    handleCancel() {
      this.visible = false
    },
    emitFromDepartInfo() {
      this.$emit('emit')
      this.visible = false
    },
  },
}
</script>

<style scoped></style>
